import axios from 'axios';

// Action Types
export const PROCESS_PAYMENT_REQUEST = 'PROCESS_PAYMENT_REQUEST';
export const PROCESS_PAYMENT_SUCCESS = 'PROCESS_PAYMENT_SUCCESS';
export const PROCESS_PAYMENT_FAILURE = 'PROCESS_PAYMENT_FAILURE';
export const CLEAR_PAYMENT_STATUS = 'CLEAR_PAYMENT_STATUS';

// Process Payment Action
export const processPayment = (paymentData) => {
  return async (dispatch) => {
    dispatch({ type: PROCESS_PAYMENT_REQUEST });
    try {
      // Assuming your backend endpoint is set up to handle payment processing
      const response = await axios.post('/api/payments', paymentData);
      dispatch({ type: PROCESS_PAYMENT_SUCCESS, payload: response.data });
    } catch (error) {
      dispatch({ type: PROCESS_PAYMENT_FAILURE, payload: error.message });
    }
  };
};

// Clear Payment Status Action
export const clearPaymentStatus = () => {
  return {
    type: CLEAR_PAYMENT_STATUS,
  };
};